import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';
import { flex, stickyFormBlock } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    modal: {
        width: 608,
        maxHeight: 'calc(100dvh - 50px)',
        fallbacks: { maxHeight: 'calc(100vh - 50px)' },
        overflowY: 'auto',
    },

    heading: {
        ...flex('row', 'space-between', ''),
    },

    loader: {
        color: theme.colors.violet_primary,
    },

    h2: {
        fontFamily: theme.font.secondary,
        fontSize: 24,
        lineHeight: 1.33,
        color: theme.colors.black,
        fontWeight: 'normal',
        marginBottom: theme.spacing(3),
    },
    field: {
        marginBottom: theme.spacing(6),
    },
    dropdown: {
        margin: 0,
    },
    errors: {
        ...stickyFormBlock(theme.colors.white),
    },
    error: {
        backgroundColor: theme.colors.red,
        marginBottom: theme.spacing(2),
    },
    text: {
        color: theme.colors.black,
        lineHeight: 1.5,
        fontSize: 16,
        fontFamily: theme.font.primary,
        marginBottom: theme.spacing(3),
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 10,
    },
    cancel: {
        textAlign: 'right',
    },
}));
